import * as React from "react"
import { graphql } from "gatsby"
import FullBackgroundHeroSection from "../../components/sections/FullBackgroundHeroSection"
import parse from "html-react-parser"
import { normalizeImageProps } from "../../utils/image"

export default ({ primary }) => {
  const {
    gold_overline_text = null,
    blue_overline_text = null,
    button_text = null,
    button_url = null,
    heading = {},
    text = {},
    image = {},
    video = {},
  } = primary

  return (
    <FullBackgroundHeroSection
      goldOverlineText={gold_overline_text}
      blueOverlineText={blue_overline_text}
      video={video}
      heading={parse(heading?.html)}
      text={parse(text?.html)}
      buttonText={button_text}
      buttonUrl={button_url}
      image={normalizeImageProps(image)}
    />
  )
}

export const query = graphql`
    fragment FullBackgroundHero on PrismicPageDataBodyFullBackgroundHero{
        slice_type
        slice_label
        __typename 
        __typename
        primary{
            gold_overline_text
            blue_overline_text
            button_text
            button_url {
                url
                target
            }
            text{
                html
                text
            }
            heading{
                html
                text
            }
            image{
                alt
                gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
            }
            video{
              url
            }
        }
    }
`
